"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Showcase() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const projects = [{
    number: "01",
    name: "ویلا مدرن لواسان",
    location: "لواسان، تهران",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/lavasan_villa_interior.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/lavasan_villa_interior.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/lavasan_villa_interior.webp-wvc-sizes",
    alt: "نمای داخلی ویلای مدرن لواسان با نورپردازی هوشمند",
    span: "lg:col-span-7 lg:row-span-2",
    height: "h-[420px] lg:h-[640px]",
    offset: ""
  }, {
    number: "02",
    name: "آپارتمان مسکونی الهیه",
    location: "الهیه، تهران",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/elahe_apartment_living.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/elahe_apartment_living.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/elahe_apartment_living.webp-wvc-sizes",
    alt: "طراحی داخلی آپارتمان لوکس در الهیه با پالت رنگی گرم",
    span: "lg:col-span-5 lg:row-span-2",
    height: "h-[420px] lg:h-[560px]",
    offset: "lg:mt-20"
  }, {
    number: "03",
    name: "دفتر کار خلاقانه",
    location: "جردن، تهران",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/jordan_office_space.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/jordan_office_space.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/jordan_office_space.png-wvc-sizes",
    alt: "فضای اداری مدرن با طراحی مینیمال و کاربردی",
    span: "lg:col-span-4 lg:row-span-2",
    height: "h-[380px] lg:h-[460px]",
    offset: "lg:mt-10"
  }, {
    number: "04",
    name: "پنت‌هاوس زعفرانیه",
    location: "زعفرانیه، تهران",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/zaferanieh_penthouse.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/zaferanieh_penthouse.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/zaferanieh_penthouse.png-wvc-sizes",
    alt: "پنت‌هاوس مجلل با دید پانوراما و متریال با کیفیت",
    span: "lg:col-span-5 lg:row-span-2",
    height: "h-[380px] lg:h-[460px]",
    offset: ""
  }, {
    number: "05",
    name: "کافه هنری آرک",
    location: "نیاوران، تهران",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/niavaran_cafe_design.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/niavaran_cafe_design.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/niavaran_cafe_design.webp-wvc-sizes",
    alt: "طراحی داخلی کافه با فضای هنری و نورپردازی خاص",
    span: "lg:col-span-3 lg:row-span-2",
    height: "h-[400px] lg:h-[560px]",
    offset: ""
  }, {
    number: "06",
    name: "خانه باغی مدرن",
    location: "کردان، کرج",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/kordan_garden_house.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/kordan_garden_house.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/kordan_garden_house.webp-wvc-sizes",
    alt: "خانه باغی با ترکیب متریال چوب و سنگ در فضای باز",
    span: "lg:col-span-8 lg:col-start-3 lg:row-span-2",
    height: "h-[360px] lg:h-[440px]",
    offset: "lg:mt-8"
  }];
  return <section data-section-id="3509" id="ویترین-خلاقیت-و-هنر" className="bg-background text-foreground py-24 md:py-36 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <div ref={header.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-24 transition-all duration-700 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <p className="font-default text-xs uppercase tracking-[0.2em] mb-6 flex items-center gap-3" style={{
            color: "var(--primary)"
          }}>
              <span className="inline-block w-8 h-px bg-[var(--primary)]" />
              پروژه‌های منتخب / ۲۰۲۴
            </p>
            <h2 className="font-default font-extrabold text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
              ویترین
              <br />
              <span className="inline-flex items-center gap-4">
                <span style={{
                color: "var(--primary)"
              }}>/</span>
                <span>خلاقیت</span>
              </span>
            </h2>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-center gap-6">
            <p className="font-serif italic text-lg md:text-xl leading-relaxed text-muted-foreground">
              شش فضا. شش فلسفه طراحی منحصر به فرد برای زندگی مدرن.
            </p>
            <Link to="/OurProjectsPage" className="group inline-flex items-center gap-3 text-foreground hover:text-[var(--primary)] transition-colors duration-300 w-fit">
              <span className="font-default text-sm uppercase tracking-[0.18em] border-b border-foreground/40 group-hover:border-[var(--primary)] pb-1 transition-colors">
                مشاهده همه پروژه‌ها
              </span>
              <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {projects.map((project, i) => <ProjectTile key={i} project={project} i={i} />)}
        </div>

        <div className="mt-20 md:mt-28 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-12 border-t border-border">
          <p className="font-serif italic text-base md:text-lg text-muted-foreground max-w-md">
            هر پروژه، داستانی از ترکیب هنر و مهندسی است که برای آرامش شما طراحی شده است.
          </p>
          <Link to="/OurProjectsPage">
            <Button variant="outline" size="lg" className="border-foreground/30 bg-transparent hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)] hover:border-[var(--primary)] text-foreground uppercase tracking-[0.18em] text-xs h-12 px-8">
              بررسی کامل نمونه‌کارها
              <ArrowRight className="size-4 ml-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}
type Project = {
  number: string;
  name: string;
  location: string;
  image: string;
  srcset: string;
  sizes: string;
  alt: string;
  span: string;
  height: string;
  offset: string;
};
function ProjectTile({
  project,
  i
}: {
  project: Project;
  i: number;
}) {
  const tile = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <div data-index={i} ref={tile.ref} className={`${project.span} ${project.offset} transition-all duration-700 ${tile.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    transitionDelay: `${i * 80}ms`
  }}>
      <Link to="/OurProjectsPage" className="group block">
        <div className={`relative ${project.height} overflow-hidden bg-card`} style={{
        boxShadow: "0 32px 80px -12px hsla(0, 0%, 0%, 0.6)"
      }}>
          <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover grayscale-[92%] group-hover:grayscale-0 scale-100 group-hover:scale-[1.03] transition-all duration-[600ms] ease-out" />

          <div className="absolute top-6 right-6 font-default text-xs uppercase tracking-[0.2em] text-[var(--primary)] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            № {project.number}
          </div>

          <div className="absolute bottom-0 left-0 w-[220px] h-[72px] bg-[var(--primary)] flex flex-col justify-center px-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
            <p className="font-default font-bold text-base text-[var(--primary-foreground)] leading-tight">
              {project.name}
            </p>
            <p className="font-default text-[10px] uppercase tracking-[0.18em] text-[var(--primary-foreground)]/80 mt-1">
              {project.location}
            </p>
          </div>

          <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none group-hover:opacity-0 transition-opacity duration-500" />
        </div>

        <div className="mt-5 flex items-baseline gap-3">
          <span className="font-default font-medium text-[11px] uppercase tracking-[0.18em]" style={{
          color: "var(--primary)"
        }}>
            № {project.number}
          </span>
          <span className="font-default font-medium text-[11px] uppercase tracking-[0.18em] text-muted-foreground group-hover:text-foreground transition-colors duration-300">
            {project.name} / {project.location}
          </span>
        </div>
      </Link>
    </div>;
}